import { JetLiftMainReport } from "../store/model/jetlift/jetliftMainreport";
import { chartDataModel, DepletionCurveGraphData, IPRplotData } from "../store/model/calculations/calculation";

const createIPRChart = (chartData: IPRplotData) => {
    let chartDataArray: any[] = []

    chartData.wiggins.forEach((data, i) => {
        var point = new chartDataModel()
        point.SeriesName = "Wiggins"
        point.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point.PointNo = "Point" + i.toString()
        chartDataArray.push(point)
    });

    chartData.vogel.forEach((data, i) => {
        var point2 = new chartDataModel()
        point2.SeriesName = "Vogel"
        point2.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point2.PointNo = "Point" + i.toString()
        chartDataArray.push(point2)
    });

    chartData.constantPi.forEach((data, i) => {
        var point3 = new chartDataModel()
        point3.SeriesName = "Gilbert"
        point3.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point3.PointNo = "Point" + i.toString()
        chartDataArray.push(point3)
    });

    chartData.compositePi.forEach((data, i) => {
        var point4 = new chartDataModel()
        point4.SeriesName = "Composite"
        point4.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point4.PointNo = "Point" + i.toString()
        chartDataArray.push(point4)
    });

    return chartDataArray
}

const createDepletionChart = (chartData: DepletionCurveGraphData) => {
    let chartDataArray: any[] = []

    chartData.wiggins.forEach((data, i) => {
        var point2 = new chartDataModel()
        point2.SeriesName = "wiggins"
        point2.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point2.PointNo = "Point" + i.toString()
        chartDataArray.push(point2)
    });

    chartData.depletion10Percent.forEach((data, i) => {
        var point2 = new chartDataModel()
        point2.SeriesName = "depletion10Percent"
        point2.PointValue = {
            IsEmpty: false,
            X: data.liquidRate,
            Y: data.fbhp
        }
        point2.PointNo = "Point" + i.toString()
        chartDataArray.push(point2)
    });

    return chartDataArray
}

const generateJetliftIPRChartAxisPoints = (chartData: any, report: JetLiftMainReport) => {
    report.iprGraphDataMaxXAxis = parseFloat(chartData?.x_Plot_MaxValue)?.toString();
    report.iprGraphDataMaxYAxis = parseFloat(chartData?.y_PlotMaxValue)?.toString();
    report.iprGraphDataXAxisInterval = parseFloat(chartData?.x_Plot_Interval)?.toString();
    report.iprGraphDataYAxisInterval = parseFloat(chartData?.y_Plot_Interval)?.toString();
}

const generateJetliftDepletionChartAxisPoints = (chartData: any, report: JetLiftMainReport) => {
    report.depletionGraphDataXMax = parseFloat(chartData?.x_Plot_MaxValue)?.toString();
    report.depletionGraphDataYMax = parseFloat(chartData?.y_Plot_MaxValue)?.toString();
    report.depletionGraphDataXAxisInterval = parseFloat(chartData?.x_Plot_Interval)?.toString();
    report.depletionGraphDataYAxisInterval = parseFloat(chartData?.y_Plot_Interval)?.toString();
};
const toStr = (v: any) => (v != null && v !== "") ? String(v) : "";
export const getJetLiftMainReportDataFromUtility = (state: any): { inputs: JetLiftMainReport, projectId: string, unitSystem: string } => {
    const { tubingInput, units } = state?.jetlift?.tubing ?? {};
    const { tab4Input } = state?.projectTab ?? {};
    const { fluidInput, region, regionList } = state?.jetlift?.fluid ?? {};
    const { jetPump } = state?.jetlift?.jetPump ?? {};
    const selectedRegion: any = regionList?.find((x: any) => x?.value === region);
    const { wellInput } = state?.jetlift?.well ?? {};
    const projectDetails: any = state?.projectTab?.tab4Input ?? tab4Input;
    const { gasIntakeData } = state?.jetlift?.gasCalculations ?? {};
    const { iprCurve, depletionCurve, showIPRPlotInMainReport, showDepletionPlotInMainReport, basicSummary, basicSummaryScenarios, formattedBasicSummaryScenarios } = state?.jetlift?.basicCalculations ?? {};
    const { jetliftProjectID, caseName: createCaseName } = state?.createProject ?? {};
    const { userRole } = state?.auth?.user ?? {};
    const inflowOutput = state?.jetlift?.well?.inflowOutput ?? state?.wellInput;

    const wellStaticBHP = wellInput?.inflowTypeLstVal === "0" ? wellInput?.reservoirPressure : wellInput?.inflowTypeLstVal === "1" ? wellInput?.sbhpForPressre : wellInput?.reservoirPressure;
    const wellTestFlowRate = wellInput?.inflowTypeLstVal === "1" ? wellInput?.flowRate : wellInput?.inflowTypeLstVal === "2" ? wellInput?.flowRateForHd : wellInput?.flowRate;

    const scenarios = Array.isArray(basicSummaryScenarios) ? basicSummaryScenarios : [];
    const scenarioVal = (s: any, keys: string[]) => {
        if (!s) return undefined;
        for (const k of keys) {
            const v = s[k];
            if (v != null && v !== "" && !Number.isNaN(Number(v))) return Number(v);
        }
        return undefined;
    };
    const getProdRate = (s: any) => scenarioVal(s, ["matchProductionRateFromGraph", "matchProdRate"]);
    const getPFP = (s: any) => scenarioVal(s, ["matchPowerFluidRate", "matchPwrFluidPress"]);
    const getQn = (s: any) => scenarioVal(s, ["matchQn", "matchPwrFluidRate"]);
    const getPIP = (s: any) => scenarioVal(s, ["matchIntakeFromGraph", "matchPumpIntakePres"]);
    const getDischarge = (s: any) => scenarioVal(s, ["discharge", "pumpDischargePrs"]);
    const getPn = (s: any) => scenarioVal(s, ["matchPn", "matchPwrFldPrsAtPmp"]);
    const s0 = scenarios[0];
    const s1 = scenarios[1];
    const s2 = scenarios[2];
    const s3 = scenarios[3];
    const fmt = (v: number | null | undefined | string) =>
        v != null && v !== "NaN" && !Number.isNaN(Number(v)) ? String(Number(v).toFixed(2)) : "";
    const fmtBlpd = (v: number | null | undefined) => (v != null && !Number.isNaN(v) ? String(v.toFixed(2)) : "");
    const fmtDischarge = (v: number | string | null | undefined) =>
        v != null && v !== "NaN" && !Number.isNaN(Number(v)) ? String(Number(v).toFixed(2)) : "";
    const performanceCurvePoints = scenarios
        .map((s: any) => {
            const flowRate = getProdRate(s);
            const pressure = getPIP(s);
            return flowRate != null && pressure != null ? { flowRate, pressure } : null;
        })
        .filter((p: { flowRate: number; pressure: number } | null): p is { flowRate: number; pressure: number } => p != null);
    const performanceCurveData = performanceCurvePoints.length > 0 ? JSON.stringify(performanceCurvePoints) : "";
    const today = new Date().toISOString().slice(0, 10);

    let report = new JetLiftMainReport();
    report.projectId = jetliftProjectID?.projectID != null ? String(jetliftProjectID.projectID) : "";
    report.documentName = (projectDetails?.caseName ?? createCaseName ?? "")?.toString() ?? "";
    report.customerName = (tab4Input?.companyName ?? projectDetails?.companyName ?? "")?.toString() ?? "";
    report.wellName = (tab4Input?.wellName ?? projectDetails?.wellName ?? "")?.toString() ?? "";
    report.projectName = (tab4Input?.projectName ?? projectDetails?.projectName ?? "")?.toString() ?? "";
    report.perforationDepth = toStr(wellInput?.perforation);
    report.pumpVerticalDepth = toStr(wellInput?.tvd);
    report.pumpInstallation = toStr(wellInput?.pumpSetting ?? wellInput?.tvd);
    report.casingProductionID = toStr(tubingInput?.casingID);
    report.powerTubingID = toStr(tubingInput?.tubing1_tubingID ?? tubingInput?.tubing2_tubingID);
    report.powerTubingOD = toStr(tubingInput?.tubing1_tubingOD ?? tubingInput?.tubing2_tubingOD);
    report.tubingLength = toStr(wellInput?.pumpSetting);
    report.pipeRoughness_ed_Ld = toStr(tubingInput?.pipeRoughness);
    report.oilGravity = toStr(fluidInput?.oilAPI);
    report.producedVolWaterCut = toStr(fluidInput?.waterCut);
    report.waterSpecificGravity = toStr(fluidInput?.spGrWater);
    report.producingGOR_scfstb = toStr(fluidInput?.gor);
    report.gasSpecificGravity = toStr(fluidInput?.spGrGas);
    report.wellStaticBHP = toStr(wellStaticBHP);
    report.pumpIntakePress = basicSummary?.pumpIntakePressure != null && basicSummary?.pumpIntakePressure !== "NaN" ? String(Number(basicSummary.pumpIntakePressure)?.toFixed(2)) : toStr(wellInput?.intakePressure);
    report.wellTestFlowRate = toStr(wellTestFlowRate);
    report.wellHeadTemp = toStr(fluidInput?.surfaceTemperature);
    report.bottomHoleTemp = toStr(fluidInput?.bottomHoleTemp);
    report.gasVented = toStr(jetPump?.gasVent);
    report.powerFluidOilWater = jetPump?.powerFluidType === "1" ? "Water" : jetPump?.powerFluidType === "2" ? "Oil" : toStr(jetPump?.powerFluidType);
    report.powerFluidAPI = jetPump?.powerFluidType?.toString() === "2" ? toStr(fluidInput?.oilAPI) : toStr(fluidInput?.spGrWater);
    report.bubblePointPress = toStr(fluidInput?.bubblePoint);
    report.wellHeadPress = toStr(wellInput?.casingPressure);
    report.reservoirPressure = toStr(wellStaticBHP);
    report.waterCut_fraction = toStr((fluidInput?.waterCut/100)?.toFixed(2));
    report.flowRate = toStr(wellInput?.flowRate);
    report.flowingBottomHolePressure = toStr(wellInput?.intakePressure);
    report.overriddenBubblePointPressure = toStr(fluidInput?.bubblePoint);
    report.targetProductionRate_blpd = toStr(wellInput?.productionRate);
    report.targetPumpIntakePressure = basicSummary?.pumpIntakePressure != null && basicSummary?.pumpIntakePressure !== "NaN" ? String(Number(basicSummary?.pumpIntakePressure)?.toFixed(2)) : "";
    report.predSurfacePowerFluidInjectionPressure = basicSummary?.surfacePowerFluidInjectionPressure != null && basicSummary?.surfacePowerFluidInjectionPressure !== "NaN" ? String(Number(basicSummary?.surfacePowerFluidInjectionPressure)?.toFixed(2)) : "";
    report.predSurfacePowerFluidInjectionRate = basicSummary?.surfacePowerFluidInjectionRate != null && basicSummary?.surfacePowerFluidInjectionRate !== "NaN" ? String(Number(basicSummary?.surfacePowerFluidInjectionRate)?.toFixed(2)) : "";
    report.predPumpIntakePressure = basicSummary?.pumpIntakePressure != null && basicSummary?.pumpIntakePressure !== "NaN" ? String(Number(basicSummary?.pumpIntakePressure)?.toFixed(2)) : "";
    report.predPumpDischargePressure = basicSummary?.pumpDischargePressure != null && basicSummary?.pumpDischargePressure !== "NaN" ? String(Number(basicSummary?.pumpDischargePressure)?.toFixed(2)) : "";
    report.predPowerFluidPressureAtPumpDepth = basicSummary?.powerFluidPressureAtPump != null && basicSummary?.powerFluidPressureAtPump !== "NaN" ? String(Number(basicSummary?.powerFluidPressureAtPump)?.toFixed(2)) : "";
    report.predHorsepowerRequirement = basicSummary?.horsePowerRequirement != null && basicSummary?.horsePowerRequirement !== "NaN" ? String(Number(basicSummary?.horsePowerRequirement)?.toFixed(2)) : "";
    report.ShowIPRPlotOnMainReport = showIPRPlotInMainReport;
    report.matchProdRate1_Blpd = fmtBlpd(getProdRate(s0));
    report.matchPowerFluidRate1_QN = fmt(getQn(s0));
    report.matchPowerFluidPress1_PFP = fmt(getPFP(s0));
    report.matchPumpIntakePress1_PIP = fmtBlpd(getPIP(s0));
    report.matchPumpDischargePress1_PD = fmtDischarge(getDischarge(s0));
    report.matchPowerFluidPress1_PN = fmt(getPn(s0));
    report.matchProdRate2_Blpd = fmtBlpd(getProdRate(s1));
    report.matchPowerFluidRate2_QN = fmt(getQn(s1));
    report.matchPowerFluidPress2_PFP = fmt(getPFP(s1));
    report.matchPumpIntakePress2_PIP = fmtBlpd(getPIP(s1));
    report.matchPumpDischargePress2_PD = fmtDischarge(getDischarge(s1));
    report.matchPowerFluidPress2_PN = fmt(getPn(s1));
    report.matchProdRate3_Blpd = fmtBlpd(getProdRate(s2));
    report.matchPowerFluidRate3_QN = fmt(getQn(s2));
    report.matchPowerFluidPress3_PFP = fmt(getPFP(s2));
    report.matchPumpIntakePress3_PIP = fmtBlpd(getPIP(s2));
    report.matchPumpDischargePress3_PD = fmtDischarge(getDischarge(s2));
    report.matchPowerFluidPress3_PN = fmt(getPn(s2));
    report.matchProdRate4_Blpd = fmtBlpd(getProdRate(s3));
    report.matchPowerFluidRate4_QN = fmt(getQn(s3));
    report.matchPowerFluidPress4_PFP = fmt(getPFP(s3));
    report.matchPumpIntakePress4_PIP = fmtBlpd(getPIP(s3));
    report.matchPumpDischargePress4_PD = fmtDischarge(getDischarge(s3));
    report.matchPowerFluidPress4_PN = fmt(getPn(s3));
    report.performanceCurveData = performanceCurveData;
    report.createdBy = toStr(state?.auth?.user?.id ?? "");
    report.updatedBy = toStr(state?.auth?.user?.id ?? "");
    report.customerEmail = toStr(projectDetails?.dalRepr ?? "");
    report.customerRole = toStr(userRole ?? "");
    report.reportFormat = 0;
    report.injectionPressureMinRange = toStr(jetPump?.minFluidRange);
    report.injectionPressureMaxRange = toStr(jetPump?.maxFluidRange);
    report.nozzleDiameter = toStr(jetPump?.nozzleDiameterSize);
    report.throatDiameter = report.throatDiameterSize = jetPump?.throatDiameterSize ? jetPump?.throatDiameterSize?.toString() : "";
    report.pI_Tangent = toStr(wellInput?.piVal);
    report.pI_Darcey = toStr(wellInput?.piVal);
    report.downloadedBy = toStr(state?.auth?.user?.name ?? state?.auth?.user?.email ?? "");
    report.downloadedDate = today;

    if (showIPRPlotInMainReport && iprCurve) {
        report.IPRGraphData = JSON.stringify(createIPRChart(iprCurve));
        generateJetliftIPRChartAxisPoints(iprCurve, report);
    }

    if (showDepletionPlotInMainReport && depletionCurve) {
        report.DepletionGraphData = JSON.stringify(createDepletionChart(depletionCurve));
        generateJetliftDepletionChartAxisPoints(depletionCurve, report);
    }

    report.unitSystem = tubingInput?.unitSys || 0;

    return {
        inputs: report,
        projectId: jetliftProjectID?.projectID?.toString() || "",
        unitSystem: (tubingInput?.unitSys || 0).toString()
    };
};